import React from 'react';
import { Provider } from 'react-redux';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { OverlayProvider } from '@react-aria/overlays';
import { ThemeProvider } from 'react-jss';
import { ProductAnalytics } from 'Context/ProductAnalytics';
import { setupStore } from '../store/store';
import { Routes } from '../routes';
import { AnalyticsManager, onetrust } from '../shared/analyticsManager';
import { ApolloRootProvider } from '../shared/hoc/Apollo';
import themes from '../../themes';

Bugsnag.start({
  apiKey: `${process.env.REACT_APP_BUGSNAG_TAG}`,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.NODE_ENV,
  // disable for GDPR
  collectUserIp: false,
  redactedKeys: [/^userkey$/i, /^sessionid$/i, /^embed$/i, /^password$/i],
  autoTrackSessions: false, // Auto Track Session is off. It will be started manually after user gives Cookie Consent.
  onError: (event) => {
    if (!onetrust.hasAnalyticsCookiesConsent()) {
      // Remove generated anonymous ID (event.device.id) from report if user do not give consent for Analytics Cookies
      // eslint-disable-next-line no-param-reassign
      event.device.id = null;
      event.setUser('[REDACTED]');
      // eslint-disable-next-line no-param-reassign
      event.breadcrumbs = null;
    }
  },
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const reduxStore = setupStore();
const App = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={themes}>
        <Provider store={reduxStore}>
          <AnalyticsManager />
          <ProductAnalytics>
            <ApolloRootProvider>
              <OverlayProvider>
                <Routes />
              </OverlayProvider>
            </ApolloRootProvider>
          </ProductAnalytics>
        </Provider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
